const mapVisibilityCriterionOption = criterion => {
  return { id: criterion.id, internal_id: criterion.internal_id, name: criterion.name }
}

export const transformResponseVisibilityCriteriaOptions = response => response.results.map(mapVisibilityCriterionOption)
